module.exports = __webpack_public_path__ + "img/5.a9936cb4.png";